var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPin = function SvgPin(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17,
    height: 23,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M8.5 0C3.807 0 0 3.605 0 8.05 0 14.088 8.5 23 8.5 23S17 14.088 17 8.05C17 3.605 13.193 0 8.5 0m0 10.925c-1.676 0-3.036-1.288-3.036-2.875S6.824 5.175 8.5 5.175s3.036 1.288 3.036 2.875-1.36 2.875-3.036 2.875"
  })));
};
export default SvgPin;